import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/app";
import StoreProvider from "./components/storeProvider/storeProvider";
import * as serviceWorker from "./serviceWorker";
import appInsights from "./utilities/loadAppInsights";

appInsights.start();

function RenderElement() {
  return (
    <StoreProvider>
      <App />
    </StoreProvider>
  );
}

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(<RenderElement />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
